var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "popupFrameworkRootBox", staticClass: "popupFrameworkRootBox" },
    [
      _c(
        "div",
        {
          ref: "popupFrameworkContentBox",
          staticClass: "popupFrameworkContentBox",
          style: { "--hoverBagColor": _vm.hoverBagColor }
        },
        [
          _c("im-frame-drag", {
            attrs: {
              "min-width": 200,
              "min-height": 300,
              "drag-el": _vm.$refs.header
            },
            on: { down: _vm.onmousedownFun, up: _vm.onmouseupFun }
          }),
          _vm._v(" "),
          _c(
            "header",
            { ref: "header", attrs: { role: "popupFrameworkHeader" } },
            [
              _c(
                "div",
                {
                  attrs: { role: "title" },
                  on: {
                    dblclick: function($event) {
                      return _vm.titleClick()
                    }
                  }
                },
                [
                  _c(
                    "el-dropdown",
                    {
                      attrs: { trigger: "hover" },
                      on: { command: _vm.nextLayer }
                    },
                    [
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.logo,
                            expression: "logo"
                          }
                        ],
                        class: _vm.logo || "el-icon-monitor",
                        attrs: { title: "调节层级" }
                      }),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-menu",
                        { attrs: { slot: "dropdown" }, slot: "dropdown" },
                        [
                          _c(
                            "el-dropdown-item",
                            { attrs: { icon: "el-icon-place", command: "2" } },
                            [_vm._v("到顶层")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown-item",
                            {
                              attrs: {
                                icon: "el-icon-refresh-left",
                                command: "0"
                              }
                            },
                            [_vm._v("还原")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._t("title", function() {
                    return [_c("span", [_vm._v(_vm._s(_vm.title))])]
                  })
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { ref: "menuBox", attrs: { role: "menu" } },
                [
                  _vm._l(_vm.menus, function(item, index) {
                    return !_vm.hideMenu.includes(index)
                      ? _c(
                          "menu",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: item.show(),
                                expression: "item.show()"
                              }
                            ],
                            key: index,
                            attrs: { title: item.title(), role: item.role },
                            on: {
                              mousedown: function($event) {
                                $event.preventDefault()
                                $event.stopPropagation()
                                return item.click()
                              }
                            }
                          },
                          [_c("i", { class: item.css() })]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _vm._t("menu")
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "main",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: {
                "background-repeat": "no-repeat",
                "background-position": "center",
                "background-size": "100%"
              },
              style: { background: _vm.blackboardMode ? "#188d68" : null },
              attrs: {
                "element-loading-text": "加载中...",
                "element-loading-spinner": "el-icon-loading"
              }
            },
            [
              _vm.mainBackgroundImage
                ? _c("img", {
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      position: "absolute",
                      left: "0",
                      top: "0"
                    },
                    attrs: { src: _vm.mainBackgroundImage }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default", function() {
                return [_c("i", { staticClass: "el-icon-loading" })]
              })
            ],
            2
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4b543a66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b543a66","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/teachingDetail/list/classroom/popupFramework.vue
// module id = null
// module chunks = 